import { Component, Input, OnInit } from '@angular/core';
import { ISystemEvent, IZoningCodeEventMetadata } from 'src/app/shared/interfaces/system-event.interface';
import * as _ from 'lodash';
import { getPrettyTaskType } from 'src/app/shared/enums/task-type-enum';

@Component({
    standalone: false,
    selector: 'tr[app-zoning-code-event-row]',
    templateUrl: './zoning-code-event-row.component.html',
    styleUrls: ['./zoning-code-event-row.component.scss']
})
export class ZoningCodeEventRowComponent implements OnInit {
    @Input()
    event: ISystemEvent<IZoningCodeEventMetadata>;

    @Input()
    index: number;

    @Input()
    stateEnv: string;

    userName: string;
    taskTypeStr: string;
    processId: string;

    constructor() {}

    ngOnInit(): void {
        const userFullName = _.get(this.event, 'MetaData.userFullName');
        const userEmail = _.get(this.event, 'MetaData.userEmail');
        this.userName =
            userFullName && userEmail
                ? `${userFullName} (${userEmail})`
                : userFullName
                ? userFullName
                : userEmail || '';

        const taskType = _.get(this.event, 'MetaData.taskType');
        this.taskTypeStr = taskType ? getPrettyTaskType(taskType) : '';
        this.processId = _.get(this.event, 'MetaData.processId');
    }
}
